<template>
  <div :style="getWrapperStyle" v-if="data">
    <div v-if="!mobile" style="height: 90%;">
      <opti-select :header="false">
        <v-text-field
          v-if="showSearch"
          slot="header"
          v-model="search"
          :label="`Filter`"
          append-icon="search"
          hide-details
          single-line>
        </v-text-field>
        <div slot="options-list">
          <template v-if="filteredElections.length > 0"
            v-for="(item, index) in filteredElections">
            <opti-select-item
              :key="index"
              :selected="$route.params.raceId"
              :value="item.election.raceId"
              @option-click="$router.push({ name: type, params: { raceId: item.election.raceId }})"
              :style="`border-left: 4px solid ${getColor(item.gopWinProbability)}; margin-bottom: 7px;`">
              <div slot="option-item-icon">
                <span class="icon-republican" :style="`font-size: 18px; color: ${getColor(item.gopWinProbability)};`" v-if="getParty(item.gopWinProbability) === 'R'"></span>
                <span class="icon-democrat" :style="`font-size: 18px; color: ${getColor(item.gopWinProbability)};`" v-if="getParty(item.gopWinProbability) === 'D'"></span>
              </div>
              <span slot="option-item-text" v-if="type === 'house'">{{ item.election.state + ' ' + item.election.cd }}</span>
              <span slot="option-item-text" v-if="type === 'senate'">{{ item.election.state }}</span>
            </opti-select-item>
          </template>
          <p slot="empty" v-if="filteredElections.length === 0" class="em ml-4">No elections found</p>
        </div>
      </opti-select>
    <div class="footnote mt-2" style="text-align: center; width: 100%;">* List color coded by GOP Win Probability</div>
    <div class="footnote mb-2" style="text-align: center; width: 100%;" v-if="type === 'house'">* At-Large - a district that encompasses a whole state rather than just a subdivision</div>
    </div>
    <v-menu class="select-menu" offset-y v-else>
      <v-btn class="select-menu-button" slot="activator" color="primary" large outline dark>
        <span style="font-size: 18px; font-weight: 500; letter-spacing: 0.1em;">Go To District</span>
        <v-icon class="ml-2">arrow_drop_down</v-icon>
      </v-btn>
      <v-list class="states-list">
        <v-list-tile
          v-for="(item, index) in filteredElections"
          :key="index"
          @click="$router.push({ name: type, params: { raceId: item.election.raceId }})">
          <v-list-tile-title>{{ item.election.state + ' ' + item.election.cd }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import omit from 'lodash.omit'
import { mapGetters } from 'vuex'

import Utils from '@/utils'
import { OptiSelect, OptiSelectItem } from '@/components/optimus'

const name = 'house_elections_list'

const props = {
  data: {
    type: Array,
    required: false
  },
  type: {
    required: true
  },
  filterState: {
    type: String,
    required: false
  },
  showSearch: {
    type: Boolean,
    required: false,
    default: false
  }
}

const components = {
  OptiSelect,
  OptiSelectItem
}

const computed = {
  ...mapGetters({
    mobile: 'ux/mobile',
    mobilePhone: 'ux/mobilePhone'
  }),
  filteredElections () {
    let elections = null
    if (this.type === 'house') {
      elections = this.data.filter(item => item.election.cd !== null)
    } else if (this.type === 'senate') {
      elections = this.data.filter(item => item.election.cd === null)
    } else {
      return []
    }

    // filter out special elections
    elections = elections.filter((item) => { return item.election.specialElection !== true })

    if (this.filterState && this.filterState !== 'United States') {
      elections = elections.filter((item) => { return item.election.state === this.filterState })
    }

    if (this.search) {
      elections = elections.filter((e) => {
        const search = this.search.trim().toLowerCase().split(/(\s+)/).filter((e) => e.trim().length > 0)
        const newObj = omit(e.election, 'electionJson')
        const item = JSON.stringify(Object.values(newObj)).toLowerCase()
        return search.every(s => item.includes(s) === true)
      })
      return elections.sort((a, b) => {
        const nameA = a.election.state + a.election.cd
        const nameB = b.election.state + b.election.cd
        return nameA.localeCompare(nameB)
      })
    } else {
      return elections.sort((a, b) => {
        const nameA = a.election.state + a.election.cd
        const nameB = b.election.state + b.election.cd
        return nameA.localeCompare(nameB)
      })
    }
  },
  getWrapperStyle () {
    let styles = ''
    if (this.mobile) {
      styles += 'display: inline-block;'
    }
    if (this.mobilePhone) {
      styles += 'width: 100%;'
    }
    return styles
  }
}

const methods = {
  getColor (value) {
    if (Utils.getColorScale(value * 100)) {
      return Utils.getColorScale(value * 100).color
    }
  },
  getParty (value) {
    if ((value * 100) >= 50) {
      return 'R'
    } else {
      return 'D'
    }
  }
}

export default {
  name,
  props,
  components,
  computed,
  methods,
  data () {
    return {
      search: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ElectionsList.vue